import { DASHBOARD_WELCOME_MESSAGE_HIDE } from 'client/redux/dashboard/constants';
import { userUpdateState } from 'client/redux/user/actionCreators';

export const dashboardWelcomeMessageHide = userId => dispatch => {
  return dispatch(userUpdateState(DASHBOARD_WELCOME_MESSAGE_HIDE, userId, {
    showWelcomeMessage: false,
  }));
};
